// src/pages/InstructorsPage.jsx
import React, { useEffect, useState } from 'react';
import '../styles/instructors.css';

const InstructorModal = ({ open, onClose, data }) => {
  useEffect(() => {
    if (!open) return;
    const onKey = (e) => e.key === 'Escape' && onClose();
    document.addEventListener('keydown', onKey);
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = '';
    };
  }, [open, onClose]);

  if (!open || !data) return null;

  return (
    <div className="modal-overlay" role="dialog" aria-modal="true" aria-labelledby="ins-modal-title">
      <div className="modal-card">
        <button className="modal-close" aria-label="닫기" onClick={onClose}>×</button>

        <header className="modal-header">
          <h3 id="ins-modal-title">강사 소개</h3>
        </header>

        <div className="modal-body">
          <div className="modal-top">
            <div className="modal-avatar">
              <img src={data.img} alt={data.name} />
            </div>
            <div className="modal-brief">
              <h4>
                <strong>{data.name}</strong>
                {data.role ? <span className="role"> {data.role}</span> : null}
              </h4>
              {data.tags?.length ? (
                <p className="tags">{data.tags.join(', ')}</p>
              ) : data.title ? (
                <p className="tags">{data.title}</p>
              ) : null}
              {data.desc && <p className="desc">{data.desc}</p>}
            </div>
          </div>

          {data.badges?.length ? (
            <ul className="cert-list">
              {data.badges.map((b, i) => (
                <li key={i}>{b}</li>
              ))}
            </ul>
          ) : null}
        </div>

        <footer className="modal-footer">
          <button className="btn-primary" onClick={onClose}>확인</button>
        </footer>
      </div>
    </div>
  );
};

const InstructorsPage = ({ data: outerData }) => {
  const [innerData, setInnerData] = useState(null);
  const data = outerData || innerData;

  const [openModal, setOpenModal] = useState(false);
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    if (outerData) return;
    (async () => {
      const res = await fetch('/content.json', { cache: 'no-cache' });
      const json = await res.json();
      setInnerData(json);
    })().catch(console.error);
  }, [outerData]);

  if (!data) return null;

  // ----- 데이터 (content.json에 없으면 fallback) -----
  const instructors = data?.instructors || [
    {
      name: '석경범',
      role: '대표 강사',
      title: '프리다이빙, 스쿠버다이빙, 수상안전교육, 생존수영전문',
      img: 'https://images.unsplash.com/photo-1607746882042-944635dfe10e?w=1000&h=1250&fit=crop',
      badges: [
        'PADI Freediver Instructor',
        'PADI Master Scuba Diver Trainer',
        'AIDA Freediver Instructor',
        'AIDA Youth Freediver Instructor',
        'Care for Children Trainer',
        'EFR Trainer',
        'Deep Instructor',
        'Delayed Surface Marker Buoy Instructor',
        'Dry Suit Instructor',
        'Emergency Oxygen Provider Instructor',
        'Enriched Air Instructor',
        'Night Diver Instructor',
        'AWARE Coral Reef Conservation Sp Instructor',
        'Open Water Scuba Instructor',
        'PADI AWARE Instructor',
        'Peak Performance Buoyancy Instructor',
        'KAPP 대한패들서프프로협회 SUP 패들 강사',
        'YMCA 수상인명구조 강사',
        '생존수영 지도자/손상예방 지도자'
      ]
    },
    {
      name: '이서연',
      role: '소속 강사',
      title: '프리다이빙 전문',
      img: 'https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e?w=1000&h=1250&fit=crop',
      badges: ['PADI Freediver Instructor', 'AIDA Judge Lv. E', 'Safety Freediver Lead']
    },
    {
      name: '김도현',
      role: '소속 강사',
      title: '스쿠버 전문',
      img: 'https://images.unsplash.com/photo-1535713875002-d1d0cf377fde?w=1000&h=1250&fit=crop',
      badges: ['OWSI', 'Dry Suit Instructor', 'Nitrox Instructor']
    },
    {
      name: '박지훈',
      role: '소속 강사',
      title: 'EFR / 응급처치',
      img: 'https://images.unsplash.com/photo-1494790108755-2616b612b786?w=1000&h=1250&fit=crop',
      badges: ['EFR Instructor', 'O2 Provider', 'Rescue workshop lead']
    }
  ];

  const collaborators = data?.collaborators || [
    {
      name: '정유나',
      role: '협력 강사',
      title: '프리다이빙 전문가',
      img: 'https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e?w=1000&h=1250&fit=crop',
      badges: ['AIDA Instructor', 'Competition Safety Team']
    },
    {
      name: '이현수',
      role: '협력 강사',
      title: '스쿠버 코치',
      img: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=1000&h=1250&fit=crop',
      badges: ['OWSI', 'Peak Performance Buoyancy Instructor']
    },
    {
      name: '최지영',
      role: '협력 강사',
      title: '응급처치 코치',
      img: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=1000&h=1250&fit=crop',
      badges: ['EFR Instructor', 'Care for Children']
    },
    {
      name: '홍성민',
      role: '협력 강사',
      title: '장비관리 전문가',
      img: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=1000&h=1250&fit=crop',
      badges: ['Equipment Specialist', 'Service Technician']
    }
  ];

  const open = (person) => { setSelected(person); setOpenModal(true); };

  return (
    <div className="instructors-page">
      {/* ✅ 히어로/탭은 AboutLayout이 렌더링하므로 여기선 제외 */}

      {/* 강사진 */}
      <section className="instructors">
        <div className="container">
          <div className="instructor-header">
            <h2>강사 소개</h2>
            <p className="instructor-copy">
              <span className="line">다이빙이지만의 공인된 강사진과 장비, 세심한 케어시스템은</span>
              <span className="line"> 물론, 무엇보다 '사람' 중심의 경험을 중시합니다.</span>
            </p>
          </div>
          <div className="instructor-grid">
            {instructors.map((ins, i) => (
              <button
                type="button"
                className="instructor-card card-vert as-button"
                key={i}
                onClick={() => open(ins)}
                aria-label={`${ins.name} 상세 보기`}
              >
                <div className="thumb">
                  <img src={ins.img} alt={ins.name} />
                  <div className="viewmore">
                    <span>VIEW</span>
                    <span>MORE</span>
                  </div>
                </div>
                <div className="info">
                  <h3>
                    <strong>{ins.name}</strong>
                    {ins.role && <span className="role"> {ins.role}</span>}
                  </h3>
                  <p className="tags">{ins.title}</p>
                </div>
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* 협력 강사진 - 클릭 및 VIEW MORE 제거 */}
      <section className="collaborators">
        <div className="container">
          <div className="instructor-header">
            <h2>협력 강사진</h2>
            <p>함께하는 파트너 강사진을 소개합니다.</p>
          </div>
          <div className="instructor-grid">
            {collaborators.map((c, i) => (
              <div
                className="instructor-card card-vert"
                key={i}
              >
                <div className="thumb">
                  <img src={c.img} alt={c.name} />
                </div>
                <div className="info">
                  <h3>
                    <strong>{c.name}</strong>
                    {c.role && <span className="role"> {c.role}</span>}
                  </h3>
                  <p className="tags">{c.title}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Modal */}
      <InstructorModal open={openModal} onClose={() => setOpenModal(false)} data={selected} />
    </div>
  );
};

export default InstructorsPage;